import React from 'react';
import HeroCarousel from './sections/HeroCarousel';
import AchievementsSection from './sections/AchievementsSection';
import StorySection from './sections/StorySection';
import RecognitionSection from './sections/RecognitionSection';
import ParentQuoteSection from './sections/ParentQuoteSection';
import YoutubeSection from './sections/YoutubeSection';
import JoinTodayBanner from './sections/JoinTodayBanner';

const MainPage = () => (
  <>
    <HeroCarousel />
    <AchievementsSection />
    <StorySection />
    <RecognitionSection />
    <ParentQuoteSection />
    <YoutubeSection />
    <JoinTodayBanner />
  </>
);

export default MainPage;
